'use strict';

function formatErrorMessageHeading(numErrors) {
  const numErrorText = (numErrors && numErrors > 0) ? numErrors : 'some';
  const usePlural = (typeof numErrorText === 'number') ? !(numErrorText === 1) : true;
  return `You have ${numErrorText} error${usePlural ? 's' : ''} on this page, please correct ${usePlural ? 'them' : 'it'} and try again`;
}

function isString(value) {
  return typeof value === 'string';
}

function isValidName(value) {
  const validNameRegex = /^[A-Za-z.\-'\s]+$/;
  return validNameRegex.test(value);
}

function exludeSymbolsTitle(value) {
  if (!value || !isString(value)) {
    return "";
  }
  return value.replace(/[^A-Za-z0-9.]+/,'');
}

function excludeSymbolsNames(value) {
  if (!value || !isString(value)) {
    return "";
  }
  return value.replace(/[^A-Za-z.\-'\s]+/,'');
}

export default {
  exludeSymbolsTitle,
  excludeSymbolsNames,
  isValidName,
  formatErrorMessageHeading
}
